import { http } from '../../config/axios'

export default function postResultadoMotorCredito(resultadoMotorCredito: any): Promise<string> {
  return http
    .post('api/resultadomotorcredito', resultadoMotorCredito)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro post resultado motor credito', error)
      throw Error(error.response.data)
    })
}
